import { Button } from '@petsmart-ui/sparky';
import Link from 'next/link';
import type { ButtonProps } from '@petsmart-ui/sparky';

export type IButtonProps = ButtonProps & {
    isNextLink?: boolean;
};

export function GenericButton({ isNextLink = false, href = '', ...props }: IButtonProps) {
    if (isNextLink) {
        return (
            <Link
                href={href}
                prefetch={false} // https://petsmart.atlassian.net/browse/HCP-594
            >
                <Button {...(props as IButtonProps)} />
            </Link>
        );
    }

    return <Button href={href} {...props} />;
}
